// extracted by mini-css-extract-plugin
export default {"loading-overlay":"JbPD7phhADpSbcIoBa12"};